<template>
  <div>
    <p class="font-weight-medium mb-8">No bill in the last 2 months.</p>
    <p class="mb-8">
      Please check
      <router-link
        class="text-primary"
        text="Junifer tickets"
        :to="{ name: 'CustomerJunifer' }"
      />
      to see if there is something that might prevent a refund, for example: a
      dispute or erroneous transfer. Issuing an incorrect refund will possibly
      put the account into debt at a later date.
    </p>

    <SoRadioGroup
      v-model="juniferAccountCheck"
      label="Is there ongoing work on the account that would affect the balance?"
      :items="[
        { text: 'Yes', value: true },
        { text: 'No', value: false },
      ]"
      @update:model-value="$emit('update:model-value', $event)"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoRadioGroup from "@/components/formControls/SoRadioGroup.vue"

  export default defineComponent({
    components: {
      SoRadioGroup,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: null,
      },
    },
    emits: ["update:model-value"],
    data() {
      return {
        juniferAccountCheck: false,
      }
    },
  })
</script>
